import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface ComunaDB {
  id: string;
  nombre: string;
  habitantes: number;
  especialistas: number;
  centros_medicos: number;
  dot_cx: number;
  dot_cy: number;
  imagen: string;
  path_indices: number[];
  orden: number;
  created_at: string;
}

export function useComunas() {
  const [data, setData] = useState<ComunaDB[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data: result, error: err } = await supabase
        .from("comunas")
        .select("*")
        .order("orden", { ascending: true });
      if (err) throw err;
      setData(result as ComunaDB[] ?? []);
    } catch {
      setError("Error cargando comunas");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}